import Seo from './Seo'

/* React */
import { useEffect, useState } from 'react'

/* Redux */
import Redux from './Wunschliste.Redux'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'
import useStyles from './styles'

/* Material-Icons */
import FavoriteIcon from '@mui/icons-material/Favorite'

/* Types */
import { isFilterProductsResponse } from 'src/shared/frontendTypes/productsFilter'

/* Functions */
import { post } from 'src/functions/fetch'

/* Components */
import Lehr from './Lehr'
import Inhalt from './Components/Inhalt/Inhalt'
import ModernWishlist from './ModernWishlist'
import useWishlistCart from './useWishlistCart'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

/* Options */
import config from 'src/config'

const breadcrumb = [
  { title: 'Wunschliste' },
]

const Wunschliste = () => {
  const classes = useStyles()
  const { items, products, deleteItem, dispatchProducts, cartItems, addCartItem } = Redux()
  const cart = useWishlistCart(items, cartItems, addCartItem)
  const [requestState, setRequestState] = useState<'idle' | 'loading' | 'ready' | 'error'>('idle')
  const [reload, setReload] = useState(0)

  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  // Die aktuellen Produkt-Daten laden

  const loadProducts = async (signal:AbortSignal) => {
    const keys = Object.keys(items)

    setRequestState('loading')
    try {
      const data = await post({
        url: 'products',
        body: { size: keys.length, keys, ...config.shop },
        signal,
      })
      if (signal.aborted) return
      if (!isFilterProductsResponse(data)) {
        setRequestState('error')
        return
      }
      dispatchProducts(data.filterProducts.products)
      setRequestState('ready')
    } catch {
      if (!signal.aborted) setRequestState('error')
    }
  }

  /* ------------------------------------------------------ */

  useEffect(() => {
    const controller = new AbortController(), signal = controller.signal
    if (Object.values(items).length > 0)
      loadProducts(signal)

    return () => controller.abort()
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items, reload]
  )
  /* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

  const shop = config.shop.shop
  if (shop === 101 || shop === 202) return <Container maxWidth='lg' className={classes.container}>
    <Seo />
    <StaticBreadcrumbs items={breadcrumb} />
    <ModernWishlist shop={shop} items={items} products={products} cart={cart}
      loading={Object.keys(items).length > 0 && (requestState === 'idle' || requestState === 'loading')}
      error={requestState === 'error'} onRemove={deleteItem} onRetry={() => setReload(value => value + 1)} />
  </Container>

  if (Object.keys(items).length === 0) return <Lehr />
  
  return <Container maxWidth='lg' className={classes.container}>

    <Seo />

    <StaticBreadcrumbs items={breadcrumb} />

    <Typo component='h1' variant='h4' color='inherit' gutterBottom>
      <FavoriteIcon/>
      {' '} Meine Wunschliste {' '}
      <FavoriteIcon/>
    </Typo>

    <div className={classes.wunschliste}>
      <Inhalt />
    </div>

  </Container>
}

export default Wunschliste
